type ModalOptions = {
  url: string,
  el: HTMLElement,
  onLoad: (el: HTMLElement) => void,
  onClose: (el: HTMLElement) => void,
}

class Modal extends EventTarget {
    elModal: HTMLElement;
    elBackdrop: HTMLElement;

    prepareModal: (cb: () => void) => void;

    constructor(opts: Partial<ModalOptions> = {}) {
        super();

        if (opts.url) {
            this.prepareModal = async (cb) => {
                
                const res = await fetch(opts.url)

                if (res.ok) {
                    const body = await res.text();

                    this.elModal.innerHTML = body

                    this.elModal.dispatchEvent(new CustomEvent("dom.load", {
                        bubbles: true
                    }))

                    cb()
                } else {
                    this.close();
                }
            }
        }

        this.init();
    }

    init() {

        const mc = document.createElement("div")
        mc.classList.add("modal-container");
        mc.setAttribute("tabindex", "-1");
        mc.setAttribute("role", "dialog");
        mc.setAttribute("aria-modal", "true");

        const mbd = document.createElement("div")
        mbd.classList.add("modal-backdrop");

        document.body.appendChild(mc)
        document.body.appendChild(mbd)

        this.elModal = mc
        this.elBackdrop = mbd

    }

    open() {
        this.elBackdrop.classList.add("modal-open");

        this.prepareModal(() => {
            this.dispatchEvent(new CustomEvent("modal.load", {detail: this}))

            this.elModal.querySelectorAll(".modal-close").forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.close();
                })
            })

            this.elModal.classList.add("modal-open");
        })
    }

    close() {
        if (this.elModal) {

            this.elModal.classList.remove("modal-open")
            this.elBackdrop.classList.remove("modal-open");

            this.dispatchEvent(new CustomEvent("modal.close", {detail: this}))
        }
    }

    destroy() {
        if (this.elModal) {
            this.dispatchEvent(new CustomEvent("modal.destroy", {detail: this}))

            this.elModal.remove();
            this.elBackdrop.remove();
        }
    }
}

export { Modal };